<template>
  <div>
    <div class="d-flex">
      <el-row :gutter="24">
        <el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">
          <div class="d-flex align-items-center" style="margin-top: 10px">
            <el-input v-model="queryParam.name" class="mb10" style="width: 240px" placeholder="请输入产品名称" clearable />
            <el-input v-model="queryParam.codeName" class="mb10 ml10" style="width: 240px" placeholder="请输入容器名称"
              clearable />
            <el-input v-model="queryParam.specName" class="mb10 ml10" style="width: 240px" placeholder="请输入产品规格"
              v-if="this.companyName.includes('五洲')" clearable />
            <el-input v-model="queryParam.partNumber" class="mb10 ml10" style="width: 240px" placeholder="请输入件号/存货编码"
              v-if="this.companyName.includes('五洲')" clearable />
            <el-button class="ml10 mb10" type="primary" @click="queryList">搜索</el-button>
            <el-button class="ml10 mb10" type="primary" @click="rest">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column prop="parentName" align="center" label="所属父级" />
      <el-table-column prop="className" align="center" label="产品名称" />
      <el-table-column prop="inventCode" align="center" label="存货编码" v-if="this.companyName.includes('五洲')">
        <template slot-scope="scope">
          {{ scope.row.inventCode || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="specName" align="center" label="规格">
        <template slot-scope="scope">
          {{ scope.row.specName || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="partNumber" align="center" label="件（图）号" v-if="this.companyName.includes('利佳')">
        <template slot-scope="scope">
          {{ scope.row.partNumber || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="warehouseName" align="center" label="位置">
        <template slot-scope="scope">
          {{ scope.row.warehouseName || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="codeName" align="center" label="所在容器">
        <template slot-scope="scope">
          {{ scope.row.codeName || '--' }}<span style="font-size: 12px;display: inline-block"
            v-if="scope.row.handle">({{scope.row.handle}})</span>
        </template>
      </el-table-column>
      <el-table-column prop="num" align="center" label="库存数" v-if="classType==0">
        <template slot-scope="scope">
          {{ scope.row.num || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="weight" align="center" label="库存(t)" v-if="classType==1">
      </el-table-column>
      <el-table-column prop="code" align="center" label="容器码" width="120px">
        <template slot-scope="scope">
          <div :id="`codeImage${scope.row.id}`">
            <vue-qr :size="200" style="width: 50px" :margin="10" :auto-color="true" :dot-scale="1"
              :text="`https://api.86122m.com/h?h=${scope.row.handle}`" />
            <!-- <div style="font-size: 12px;font-weight: bold">{{scope.row.className}}</div> -->
          </div>
        </template>
      </el-table-column>
      <template slot="empty">
        <div class="empty-text">{{ emptyText }}</div>
      </template>
    </el-table>
    <div class="pageBox">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNum" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" class=""
        :total="total" :pager-count="5" />
    </div>
  </div>

</template>

<script>
  import { selectClass } from '@/api/storeCode.js'
  import { codeUrl } from '@/utils/constant'
  import VueQr from 'vue-qr'

  export default {
    components: { VueQr },
    props: {
      classType: {
        default: 0
      },
      storeStatus: {
        default: '0'
      }
    },
    data() {
      return {
        codeUrl: codeUrl,
        companyName: (() => {
          const companyList = JSON.parse(localStorage.getItem("info")).companyList;
          if (companyList) {
            try {
              const parsedCompanyList = companyList;
              return parsedCompanyList[0] ? parsedCompanyList[0].companyName : '';
            } catch (e) {
              console.error("解析 companyList 失败:", e);
              return '';
            }
          }
          return '';
        })(),
        name: null,
        tableData: [],
        pageSize: 10,
        pageNum: 1,
        total: 0,
        currentPage: 1,
        status: '',
        queryParam: {
          name: '',
          specName: '',
          partNumber: '',
          codeName: ''
        }
      };
    },
    created() {
      this.getList();
    },
    computed: {
      emptyText() {
        // 如果有搜索条件，显示具体的无结果提示
        if (this.queryParam.codeName) {
          return '无此容器码';
        }
        if (this.queryParam.name) {
          return '无此产品';
        }
        // 默认提示
        return '产品类别无此产品';
      }
    },
    methods: {
      queryList() {
        this.pageNum = 1
        this.getList()
      },
      rest() {
        this.queryParam.name = ''
        this.queryParam.specName = ''
        this.queryParam.partNumber = ''
        this.queryParam.codeName = ''
        this.pageNum = 1
        this.currentPage = 1
        this.getList()
      },
      getStockNum(row, num) {
        num += row.stockNum
        if (row.children && row.children.length > 0) {
          row.children.forEach(item => {
            num += item.stockNum;
            this.getStockNum(item, num)
          })
        }
        return num;
      },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.getList();
      },
      getList() {
        let param = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          classType: this.classType
        }
        let params = Object.assign(param, this.queryParam)
        selectClass(params).then(res => {
          this.tableData = res.data.list
          this.total = res.data.total
        })
      },
    },

  }
</script>

<style lang="scss" scoped>
  .ml10 {
    margin-left: 10px;
  }

  .pageBox {
    display: flex;
    justify-content: flex-end;
  }
</style>